import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Landing from "./components/Landing";
import Login from "./pages/Login";
import Register from "./components/Register";
import UserDashboard from "./pages/UserDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import AgentDashboard from "./pages/AgentDashboard";
import EnhancedUserDashboard from "./pages/EnhancedUserDashboard";
import BookingCreate from "./pages/BookingCreate";
import AgencyDetails from "./pages/AgencyDetails";
import ProtectedRoute from "./components/ProtectedRoute";
import SessionWarning from "./components/SessionWarning";
import AeroIndustrialHubPage from "./pages/Properties/AeroIndustrialHubPage";
import AeroIndustrialTypeDetail from "./pages/Properties/AeroIndustrialTypeDetail";
import Profile from "./pages/Profile";
import AdminSidebar from "./components/AdminSidebar";
import UsersManagement from "./components/admin/UsersManagement";
import BookingsManagement from "./components/admin/BookingsManagement";
import AdminBookingsManagement from "./components/admin/AdminBookingsManagement";
import BookingRequestsManagement from "./components/admin/BookingRequestsManagement";
import AgencyRequestsManagement from "./components/admin/AgencyRequestsManagement";
import AgenciesManagement from "./components/admin/AgenciesManagement";
import AgentAdminsManagement from "./components/admin/AgentAdminsManagement";
import LotsManagement from "./components/admin/LotsManagement";
import AgencyRequest from "./components/AgencyRequest";
import "./App.css";

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <SessionWarning />
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Header />
                  <main className="main-content">
                    <Landing />
                  </main>
                  <Footer />
                </>
              }
            />
            <Route
              path="/properties"
              element={<Navigate to="/aero-industrial-hub" replace />}
            />
            <Route
              path="/login"
              element={
                <>
                  <Header />
                  <main className="main-content">
                    <Login />
                  </main>
                  <Footer />
                </>
              }
            />
            <Route
              path="/register"
              element={
                <>
                  <Header />
                  <main className="main-content">
                    <Register />
                  </main>
                  <Footer />
                </>
              }
            />
            <Route
              path="/agency-request"
              element={
                <>
                  <Header />
                  <main className="main-content">
                    <AgencyRequest />
                  </main>
                  <Footer />
                </>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute requiredRole="user">
                  <>
                    <Header />
                    <main className="main-content">
                      <UserDashboard />
                    </main>
                    <Footer />
                  </>
                </ProtectedRoute>
              }
            />
            <Route
              path="/enhanced-dashboard"
              element={
                <ProtectedRoute requiredRole="user">
                  <>
                    <Header />
                    <main className="main-content">
                      <EnhancedUserDashboard />
                    </main>
                    <Footer />
                  </>
                </ProtectedRoute>
              }
            />
            <Route
              path="/agent-dashboard"
              element={
                <ProtectedRoute requiredRole="agent_admin">
                  <>
                    <Header />
                    <main className="main-content">
                      <AgentDashboard />
                    </main>
                    <Footer />
                  </>
                </ProtectedRoute>
              }
            />
            <Route
              path="/agent/booking-requests"
              element={
                <ProtectedRoute requiredRole="agent_admin">
                  <>
                    <Header />
                    <main className="main-content">
                      <div className="admin-container">
                        <AdminSidebar />
                        <div className="admin-content">
                          <BookingRequestsManagement />
                        </div>
                      </div>
                    </main>
                    <Footer />
                  </>
                </ProtectedRoute>
              }
            />
            <Route
              path="/agent/agency-requests"
              element={
                <ProtectedRoute requiredRole="agent_admin">
                  <>
                    <Header />
                    <main className="main-content">
                      <div className="admin-container">
                        <AdminSidebar />
                        <div className="admin-content">
                          <AgencyRequestsManagement />
                        </div>
                      </div>
                    </main>
                    <Footer />
                  </>
                </ProtectedRoute>
              }
            />
            <Route
              path="/bookings/create"
              element={
                <ProtectedRoute requiredRole="agent_admin">
                  <>
                    <Header />
                    <main className="main-content">
                      <BookingCreate />
                    </main>
                    <Footer />
                  </>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin-dashboard"
              element={
                <ProtectedRoute requiredRole="super_admin">
                  <>
                    <Header />
                    <main className="main-content">
                      <AdminDashboard />
                    </main>
                    <Footer />
                  </>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/users"
              element={
                <ProtectedRoute requiredRole="super_admin">
                  <>
                    <Header />
                    <main className="main-content">
                      <div className="admin-container">
                        <AdminSidebar />
                        <div className="admin-content">
                          <UsersManagement />
                        </div>
                      </div>
                    </main>
                    <Footer />
                  </>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/agencies"
              element={
                <ProtectedRoute requiredRole="super_admin">
                  <>
                    <Header />
                    <main className="main-content">
                      <div className="admin-container">
                        <AdminSidebar />
                        <div className="admin-content">
                          <AgenciesManagement />
                        </div>
                      </div>
                    </main>
                    <Footer />
                  </>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/agent-admins"
              element={
                <ProtectedRoute requiredRole="super_admin">
                  <>
                    <Header />
                    <main className="main-content">
                      <div className="admin-container">
                        <AdminSidebar />
                        <div className="admin-content">
                          <AgentAdminsManagement />
                        </div>
                      </div>
                    </main>
                    <Footer />
                  </>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/lots"
              element={
                <ProtectedRoute requiredRole="super_admin">
                  <>
                    <Header />
                    <main className="main-content">
                      <div className="admin-container">
                        <AdminSidebar />
                        <div className="admin-content">
                          <LotsManagement />
                        </div>
                      </div>
                    </main>
                    <Footer />
                  </>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/bookings"
              element={
                <ProtectedRoute requiredRole="super_admin">
                  <>
                    <Header />
                    <main className="main-content">
                      <div className="admin-container">
                        <AdminSidebar />
                        <div className="admin-content">
                          <AdminBookingsManagement />
                        </div>
                      </div>
                    </main>
                    <Footer />
                  </>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/all-bookings"
              element={
                <ProtectedRoute requiredRole="super_admin">
                  <>
                    <Header />
                    <main className="main-content">
                      <div className="admin-container">
                        <AdminSidebar />
                        <div className="admin-content">
                          <BookingsManagement />
                        </div>
                      </div>
                    </main>
                    <Footer />
                  </>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/agencies/:id"
              element={
                <ProtectedRoute requiredRole="super_admin">
                  <AgencyDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <>
                    <Header />
                    <main className="main-content">
                      <Profile />
                    </main>
                    <Footer />
                  </>
                </ProtectedRoute>
              }
            />
            <Route
              path="/properties/aeroindustrial/type/:typeId"
              element={
                <>
                  <Header />
                  <main className="main-content">
                    <AeroIndustrialTypeDetail />
                  </main>
                  <Footer />
                </>
              }
            />
            <Route
              path="/aero-industrial-hub"
              element={
                  <>
                    <Header />
                    <main className="main-content">
                    <AeroIndustrialHubPage />
                    </main>
                    <Footer />
                  </>
              }
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
